<template lang="pug">
div 
  .columns.is-mobile
    .column.is-one-fifth.week-heading
        TaskLabel(:task='task')
        div(style="margin-top:0.25rem")
          button.is-hidden-tablet.button.is-fullwidth.is-success.sharp(:disabled='!$store.getters.unconfirmed(task)', style="height:100%", @click='$emit("confirm", task)')  Confirm
    .column.day-column(v-for="d in days")
        TaskCell(:task='task', :day="day_of_week(d)")
    
    .column.day-column.is-hidden-touch
      button.button.is-fullwidth.is-success.sharp(:disabled='!$store.getters.unconfirmed(task)', style="height:100%", @click='$emit("confirm", task)')  Confirm

    
</template>

<script>
import { mapState } from "vuex";
import TaskCell from "@/components/TaskCell";
import TaskLabel from "@/components/TaskLabel";
import moment from "moment";
export default {
  name: "TaskRow",
  components: {
    TaskCell,
    TaskLabel
  },
  computed: {
    ...mapState(["weekends"]),
    days() {
      if (this.weekends) {
        return [0, 1, 2, 3, 4, 5, 6];
      } else {
        return [1, 2, 3, 4, 5];
      }
    },
    sunday() {
      return this.day_of_week(0);
    },
    monday() {
      return this.day_of_week(1);
    },
    tuesday() {
      return this.day_of_week(2);
    },
    wednesday() {
      return this.day_of_week(3);
    },
    thursday() {
      return this.day_of_week(4);
    },
    friday() {
      return this.day_of_week(5);
    },
    saturday() {
      return this.day_of_week(6);
    }
  },
  props: ["task"],
  mounted: function() {},
  methods: {
    day_of_week(offset) {
      const m = moment(this.$store.state.sunday);
      m.add(offset, "days");
      return m.format("YYYY-MM-DD");
    }
  }
};
</script>

<style scoped lang="less">
.sharp {
  border-radius: 0px !important;
}
</style>